// Home.js
import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div>
            <h1>Welcome to Our Application</h1>
            <p>This is the main homepage of the app.</p>
            <Link to="/profile">Go to Your Profile</Link>
        </div>
    );
};

export default Home;
